import { useLoginUser } from '@/src/views/states/LoginUser'
import { useCallback, useEffect, useState } from 'react'
import { ExternalUrlService } from '../../../../services/ExternalUrlService'
import { useProcessingContactsContext } from '../../../states/ProcessingContactsContext'
import { Props } from './Layout'
import { AuthService } from '@/src/services/AuthService'

export const useProps = (): Props => {
  const onClickStaking = useCallback(() => window.open(ExternalUrlService.getStakingUrl()), [])
  const onClickMarketPlace = useCallback(() => window.open(ExternalUrlService.getTofuNftAkiverseAPPage()), [])
  const walletAddress = useLoginUser().loginUser?.walletAddress ?? ''
  const [isLoggedIn, setLoggedIn] = useState(false)
  const {
    depositingGameCenters,
    withdrawingGameCenters,
    depositingArcadeMachines,
    withdrawingArcadeMachines,
    depositingArcadeParts,
    withdrawingArcadeParts,
    depositingAKV,
    withdrawingAKV,
    depositingAKIR,
    withdrawingAKIR,
  } = useProcessingContactsContext()

  useEffect(() => {
    setLoggedIn(AuthService.isLoggedIn())
  }, [])

  return {
    onClickMarketPlace,
    onClickStaking,
    connectedWallet: walletAddress,
    visibleSpinner:
      [
        ...depositingGameCenters,
        ...withdrawingGameCenters,
        ...depositingArcadeMachines,
        ...withdrawingArcadeMachines,
        ...depositingArcadeParts,
        ...withdrawingArcadeParts,
        ...depositingAKV,
        ...withdrawingAKV,
        ...depositingAKIR,
        ...withdrawingAKIR,
      ].length > 0,
    depositing: [
      ...depositingGameCenters.map((gc) => gc.name),
      ...depositingArcadeMachines.map((am) => am.name),
      ...depositingArcadeParts.map((ap) => ap.name),
      ...depositingAKV.map((akv) => `AKV x${Number(akv.amount.toAKV()).toLocaleString()}`),
      ...depositingAKIR.map((akir) => `AKIR x${Number(akir.amount).toLocaleString()}`),
    ],
    withdrawing: [
      ...withdrawingGameCenters.map((gc) => gc.name),
      ...withdrawingArcadeMachines.map((am) => am.name),
      ...withdrawingArcadeParts.map((ap) => ap.name),
      ...withdrawingAKV.map((akv) => `AKV x${Number(akv.amount.toAKV()).toLocaleString()}`),
      ...withdrawingAKIR.map((akir) => `AKIR x${Number(akir.amount).toLocaleString()}`),
    ],
    isLoggedIn,
  }
}
